/**
 * Created by fers on 26.09.15.
 */

import {declareEntity} from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "userIdentity",
    graphQL: "UserIdentity",
    name: "User Identities",
    dynamoPrefix: 'app',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "uuid",
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            userEditable: false,
        },
        identity: {
            name: "Identity",
            type: "string",
            defaultValue: "",
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        user: {
            name: "User",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
